import { useState, useEffect } from "react";
import { CommuneTypes } from "../types";
import { BFF_URL, HEADERS } from "../constants";

const ENDPOINT = `${BFF_URL}/communes?active=true`;

export const useCommunes = (): { communes: CommuneTypes; error?: string } => {
  const [communes, setCommunes] = useState<CommuneTypes>([]);
  const [error, setError] = useState<undefined | string>();

  useEffect(() => {
    const fetchAllCommunes = async () => {
      try {
        const response: Response = await fetch(ENDPOINT, { headers: HEADERS });
        const responseBody = await response.json();
        if (response.ok) {
          const mappedCommunes =
            responseBody.data &&
            responseBody.data.map((item: { id: string; attributes: Record<string, unknown> }) => ({
              id: item.id,
              ...item.attributes
            }));
          setCommunes(mappedCommunes);
        } else {
          setError(responseBody.statusCode);
        }
      } catch (error) {
        let message = error as string;
        if (error instanceof Error) {
          message = error.message;
        }
        setError(message);
      }
    };
    fetchAllCommunes();
  }, []);

  return { communes, error };
};
